import styled from "styled-components"

export const ButtonCallAction = styled.div`
  color:#FADC71;
  padding: 0.8em 1.2em;
  border-radius: 0px 40px 40px 0px;
  
`
